import { Direction } from '@angular/cdk/bidi';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ElementDirectionService } from '@fleet-beat/core';
import { EditorConfig, EditorConfigTranslateService } from '@fleet-beat/editor';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddDocumentsDialogOptions } from '../../models/add-document-dialog-options.model';
import { AddDocumentDialogEditorService } from '../../services/add-document-dialog-editor.service';

@Component({
  selector: 'fb-add-document-dialog-container',
  templateUrl: './add-document-dialog-container.component.html',
  styleUrls: ['./add-document-dialog-container.component.scss'],
  providers: [AddDocumentDialogEditorService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddDocumentDialogContainerComponent extends OnDestroyMixin implements OnInit {
  readonly form: FormGroup = this.addDialogEditorService.form;
  readonly config$: BehaviorSubject<EditorConfig> = new BehaviorSubject<EditorConfig>(null);
  readonly elementDirection$: Observable<Direction> = this.elementDirectionService.direction$;
  requireDocument: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public matDialogdata: AddDocumentsDialogOptions,
    private dialogRef: MatDialogRef<AddDocumentDialogContainerComponent>,
    private addDialogEditorService: AddDocumentDialogEditorService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private editorConfigTranslateService: EditorConfigTranslateService,
    private elementDirectionService: ElementDirectionService,
  ) {
    super();
    this.matIconRegistry.addSvgIcon(
      'driver-license',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/driver-license.svg'),
    );

    this.editorConfigTranslateService
      .translate(this.addDialogEditorService.config.editor)
      .pipe(untilComponentDestroyed(this))
      .subscribe((config: EditorConfig) => this.config$.next(config));
  }

  ngOnInit(): void {
    this.form.reset();
    if (this.matDialogdata.requireDocument) {
      this.form.get('title').setValue(this.matDialogdata.title);
      this.requireDocument = true;
    }
  }
  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.addDialogEditorService.getOutput());
  }
}
